import {
  Block,
  Button,
  ParagraphMedium,
  ParagraphSmall,
  ShieldZap,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { links } from "#/shared/constants"

import FailedActionModalBody from "../FailedActionModalBody"

export default function ClaimingFailedBody({
  onClose,
  suggestSupport,
}: {
  onClose: () => void
  suggestSupport?: boolean
}) {
  const [css, theme] = useStyletron()
  return (
    <FailedActionModalBody
      onClickNextStep={onClose}
      footer={
        <Block
          className={css({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          })}
        >
          <ParagraphMedium
            color={theme.colors.contentTertiary}
            className={css({
              textAlign: "center",
              marginBottom: suggestSupport
                ? theme.sizing.scale2400
                : theme.sizing.scale3200,
            })}
          >
            {suggestSupport ? (
              <>
                If the problem continues, you can contact <br /> Mezo Support on
                Discord.
              </>
            ) : (
              <>
                You can close this window.
                <br /> A message will let you know when to try again.
              </>
            )}
          </ParagraphMedium>

          <Block
            className={css({
              display: "flex",
              gap: theme.sizing.scale300,
              alignItems: "center",
              marginBottom: theme.sizing.scale800,
            })}
          >
            <ShieldZap
              color={theme.colors.backgroundAccent}
              size={theme.sizing.scale700}
            />
            <ParagraphSmall>
              Your mats are reserved. You&apos;ll be able to claim shortly.
            </ParagraphSmall>
          </Block>
          {suggestSupport && (
            <Button
              $as="a"
              href={links.DISCORD_SUPPORT}
              target="_blank"
              kind="secondary"
              size="large"
              overrides={{
                Root: {
                  style: () => ({
                    width: "100%",
                    marginBottom: theme.sizing.scale500,
                  }),
                },
              }}
            >
              Contact Support
            </Button>
          )}
          <Button
            width="100%"
            size="large"
            onClick={onClose}
            kind={suggestSupport ? "tertiary" : "secondary"}
          >
            Close
          </Button>
        </Block>
      }
    />
  )
}
